import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { checkAuth, logout } from "./sessionSlice"

export interface GroupFilterState {
  selectedByOrganization: Record<string, string[]>
}

const initialState: GroupFilterState = {
  selectedByOrganization: {},
}

const groupFilterSlice = createSlice({
  name: "groupFilter",
  initialState,
  reducers: {
    setOrganizationGroups: (
      state,
      action: PayloadAction<{ organizationId: string; groupIds: string[] }>
    ) => {
      const { organizationId, groupIds } = action.payload

      if (groupIds.length > 0) {
        state.selectedByOrganization[organizationId] = Array.from(
          new Set(groupIds)
        )
      } else {
        delete state.selectedByOrganization[organizationId]
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, () => initialState)
      .addCase(checkAuth.rejected, () => initialState)
  },
})

export const { setOrganizationGroups } = groupFilterSlice.actions
export default groupFilterSlice.reducer

const EMPTY_GROUPS: string[] = []

export const selectOrganizationGroups = (
  state: { groupFilter: GroupFilterState },
  organizationId: string
) => state.groupFilter.selectedByOrganization[organizationId] ?? EMPTY_GROUPS
